var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 19,
    viewBox: "0 0 202 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 67.065,
    y: 4.07111,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.9942,
    y: 4.3418,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9942,
    y: 4.3418,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 4.75,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 4.75,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 73.1071,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0363,
    y: 6.37726,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0421,
    y: 6.78546,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.04208,
    y: 6.78546,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 79.1469,
    y: 0.679108,
    width: 2.01498,
    height: 16.9643,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0761,
    y: 0.950012,
    width: 2.01498,
    height: 16.9643,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 85.1912,
    y: 4.07089,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 49.1204,
    y: 4.3418,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 91.2332,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 55.1625,
    y: 6.37726,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 97.2731,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 61.2023,
    y: 6.37726,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 103.315,
    y: 4.07089,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 109.357,
    width: 2.01498,
    height: 19,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 115.399,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 121.444,
    y: 4.07089,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 127.481,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 139.568,
    y: 0.679108,
    width: 2.01498,
    height: 16.9643,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 145.61,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 151.652,
    y: 6.78546,
    width: 2.01498,
    height: 5.42857,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 157.691,
    y: 4.07089,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 163.736,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 169.778,
    y: 2.71454,
    width: 2.01498,
    height: 13.5714,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 175.82,
    y: 4.07089,
    width: 2.01498,
    height: 10.1786,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 181.86,
    y: 6.10635,
    width: 2.01498,
    height: 6.78571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 187.904,
    y: 6.78546,
    width: 2.01498,
    height: 5.42857,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 193.946,
    y: 8.14273,
    width: 2.01498,
    height: 2.71429,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 199.986,
    y: 8.95172,
    width: 2.01498,
    height: 2.03571,
    rx: 1.00749,
    fill: "#6F6F6F"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 133.525,
    y: 2.71454,
    width: 2.01498,
    height: 13.5714,
    rx: 1.00749,
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.601dd2e07b91ee588a81800d638492c1.svg";
export { ForwardRef as ReactComponent };